import type { ColumnsType } from 'antd/es/table';

/**
 * 列表列宽统一口径：固定列按内容类型给宽度，主描述列留 ellipsis 弹性吸收剩余空间，
 * 避免「短列挤成一堆、长列独占大屏」。各端列表列定义优先引用这里，
 * 新增表格用 sumWidth() 核算横向滚动值（保证「操作」列 fixed: 'right' 生效）。
 */
export const COL = {
  /** 单据号（HQ/SL/DL 等 20+ 字符） */
  bizNo: 190,
  /** 物资/机构编码 */
  code: 140,
  /** 机构 / 科室名称 */
  dept: 150,
  /** 人名 */
  person: 100,
  /** 状态标签 */
  status: 110,
  /** 数量（右对齐） */
  qty: 100,
  /** 金额 / 单价（右对齐） */
  amount: 120,
  /** 日期时间 YYYY-MM-DD HH:mm */
  time: 160,
  /** 纯日期 YYYY-MM-DD */
  date: 120,
  /** 是/否等短标记 */
  flag: 90,
  /** 单按钮操作列（配合 fixed: 'right'） */
  action1: 90,
  /** 双按钮操作列 */
  action2: 150,
  /** 三按钮操作列 */
  action3: 200
} as const;

/** 没有显式 width 的列（弹性列）按最小可读宽度估算，用于核算 scroll.x。 */
const FLEX_MIN_WIDTH = 160;

/**
 * 按列定义估算表格所需横向滚动宽度：全部列宽求和 + 操作列余量。
 * 用法：scroll={{ x: sumWidth(columns) }}，保证 fixed 列在窄视口下真正固定。
 */
export function sumWidth<T>(columns: ColumnsType<T>): number {
  let total = 0;
  for (const col of columns) {
    if ('children' in col && Array.isArray(col.children)) {
      // 分组表头：取一层的最大值即可
      total += Math.max(...col.children.map((c) => ('width' in c && typeof c.width === 'number' ? c.width : FLEX_MIN_WIDTH)), FLEX_MIN_WIDTH);
    } else if ('width' in col && typeof col.width === 'number') {
      total += col.width;
    } else {
      total += FLEX_MIN_WIDTH;
    }
  }
  return total;
}
